import { Button } from 'src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import { openChat } from 'src/utils';
import { CmsContent } from 'src/components/CmsContent';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { useModalContext } from 'src/hooks/useModalContext';

const DepositPaymentInfoModal = () => {
  const { modalProps, closeModal } = useModalContext<{
    text: { title: string | undefined; content: string | undefined } | undefined;
  }>();
  const { t } = useTranslation();

  return (
    <ModalWrapper>
      <div className="p-[20px] max-w-[600px] flex flex-col gap-7">
        <div>
          <p className="text-2xl text-center text-dpip_title font-bold">
            {modalProps?.text?.title}
          </p>
        </div>
        <CmsContent
          className="static-page text-dpip_text cms-dropdown"
          content={modalProps?.text?.content || ''}
        />
        <div className="w-full flex justify-center items-center pb-[30px]">
          <Button
            title={t('modalCancelBonus.ask') as string}
            label={t('modalCancelBonus.ask') as string}
            className="w-full max-w-[300px] mt-[15px]"
            mode="button-secondary"
            onClick={() => {
              closeModal();
              openChat();
            }}
          />
        </div>
      </div>
    </ModalWrapper>
  );
};

// eslint-disable-next-line no-restricted-exports
export default DepositPaymentInfoModal;
